import { render, staticRenderFns } from "./mSizer.vue?vue&type=template&id=6a585fa8&"
import script from "./mSizer.vue?vue&type=script&lang=js&"
export * from "./mSizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports